import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createMachine } from '@/apis/machines'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { CreateMachineRequest } from '@/types/apis/machines/CreateMachineRequest'
import { CreateMachineResponse } from '@/types/apis/machines/CreateMachineResponse'

export const useCreateMachine = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<CreateMachineResponse>()

  const create = useCallback(
    async (request: CreateMachineRequest) => {
      try {
        setLoading(true)
        const res = await createMachine(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        navigate(routes.machines.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createMachine: create,
    response,
  }
}
